module.exports = {
          srcSet: __webpack_public_path__ + "images/1925-2-92e0704eae916d6465c76db9b69f8cf0-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1925-2-c5e3d6a722cc1883f77f9652de6f7466-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1925-2-92e0704eae916d6465c76db9b69f8cf0-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1925-2-c5e3d6a722cc1883f77f9652de6f7466-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1925-2-92e0704eae916d6465c76db9b69f8cf0-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1925-2-92e0704eae916d6465c76db9b69f8cf0-320.jpg"},
          
          width: 320,
          height: 251
        }